import { useState } from "react";
import { db, auth } from "../../firebase";
import "../../css/AddForm.css";
import {
  collection,
  addDoc,
  Timestamp,
  serverTimestamp,
} from "firebase/firestore";
import { nanoid } from "nanoid";

export default function AddForm(props) {
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [isSaved, setisSaved] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  // function handleSubmit(e) {
  //   e.preventDefault();
  //   if (name !== "") {
  //     props.addItem(name);
  //     setName("");
  //   } else {
  //     alert("No empty item accepted...");
  //   }
  // }

  const month = props.month;

  /* function to add new task to firestore */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    try {
      await addDoc(collection(db, month), {
        title: title,
        // vote: vote,
        text: text,
        //image_name: selectedFile.name,
        created: serverTimestamp(),
        userUID: user.uid,

        //key: "item " + nanoid(),
      });
      setTitle("");
      // setVote("-");
      setText("");
      setisSaved(true);
      props.handleView();
    } catch (err) {
      alert(err);
    }
  };

  function TitlehandleChange(e) {
    setTitle(e.target.value);
  }

  function TexthandleChange(e) {
    setText(e.target.value);
  }

  function PhotoHandleChange(e) {
    setSelectedFile(e.target.files[0]);
  }

  return (
    <form onSubmit={handleSubmit} className="stack-small">
      <div className="form-group">
        {/* <label htmlFor="title" className="label__lg">
          Τίτλος
        </label> */}

        <div class="col-auto">
          <input
            type="text"
            id="title"
            name="title"
            autoComplete="off"
            value={title}
            onChange={TitlehandleChange}
            placeholder="Τίτλος"
          />
        </div>

        {/* <label htmlFor="item_comment" className="label__lg">
          Σχόλια
        </label> */}

        <div class="col-auto">
          <textarea
            rows="9"
            columns="10"
            id="item_comment"
            name="item_comment"
            autoComplete="off"
            value={text}
            onChange={TexthandleChange}
            placeholder="Σχόλια"
          >
            {" "}
          </textarea>
        </div>

        <br></br>
        <button type="submit" class="btn btn-success btn-md center-block">
          Save
        </button>
      </div>
    </form>
  );
}
